import { ActivityIndicator, Pressable, StyleSheet, View } from "react-native";

import { GText } from "@/components/g-text";
import { colors } from "@/constants/colors";

interface BottomEventButtonProps {
  disabled?: boolean;
  label: string;
  onPress: () => void;
  saving?: boolean;
  vScale: number;
}

export default function BottomEventButton({
  disabled = false,
  label,
  onPress,
  saving = false,
  vScale,
}: BottomEventButtonProps) {
  return (
    <View style={[styles.bottomContainer]}>
      <View style={[styles.bottomInner]}>
        <Pressable
          disabled={disabled}
          onPress={onPress}
          style={[
            styles.bottomButton,
            {
              borderRadius: 28 * vScale,
              paddingHorizontal: 32 * vScale,
              paddingVertical: 16 * vScale,
            },
            disabled && styles.disabledOpacity,
          ]}
        >
          {saving ? (
            <ActivityIndicator color={colors.black} />
          ) : (
            <GText style={[styles.bottomText, { fontSize: 18 * vScale }]}>
              {label}
            </GText>
          )}
        </Pressable>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  bottomButton: {
    alignItems: "center",
    backgroundColor: colors.white,
    borderRadius: 28,
    marginBottom: 10,
    paddingHorizontal: 32,
    paddingVertical: 16,
    width: "100%",
  },
  bottomContainer: {
    bottom: 10,
    left: 10,
    position: "absolute",
    right: 10,
  },
  bottomInner: {
    alignSelf: "center",
    maxWidth: 600,
    width: "100%",
  },
  bottomText: {
    color: colors.black,
    fontSize: 18,
    fontWeight: "600",
  },
  disabledOpacity: {
    opacity: 0.5,
  },
});
